import { AxiosError } from 'axios';
import { getBaseURL, getClient } from '../../BLL/clients/HttpClient';
import { ApiEndPoint } from '../../BLL/Enums/ApiEndPoint';
import { VobAuthCodesParams, VobAuthCodesResponse } from './types';

/**
 * Fetch VOB authorization codes with filtering and pagination
 * @param params The query parameters for filtering and pagination
 * @returns A promise that resolves to the response from the server
 */
export const getVobAuthCodes = async (
  params: VobAuthCodesParams
): Promise<VobAuthCodesResponse> => {
  try {
    const authBaseUrl = getBaseURL(ApiEndPoint.Auth);
    const client = getClient({ baseURL: authBaseUrl });

    // Build query string
    const queryParams = new URLSearchParams();
    queryParams.append('page', params.page.toString());
    queryParams.append('pageSize', params.pageSize.toString());
    queryParams.append('sortBy', params.sortBy);
    queryParams.append('sortOrder', params.sortOrder);
    
    if (params.authCode) {
      queryParams.append('authCode', params.authCode);
    }
    
    if (params.policyNumber) {
      queryParams.append('policyNumber', params.policyNumber);
    }

    // Fetch auth codes from the backend
    const response = await client.get(
      `v1/support/fax-authorization-codes?${queryParams.toString()}`
    );

    return response.data;
  } catch (error) {
    const e = error as AxiosError;
    const errorResponse = e.response?.data as
      | { errors: { message: string }[] }
      | undefined;
    
    console.error('Error fetching VOB authorization codes:', error);
    
    if (
      errorResponse &&
      errorResponse.errors &&
      errorResponse.errors.length > 0
    ) {
      throw new Error(errorResponse.errors.map((x) => x.message).join(', '));
    }
    
    throw new Error(
      'An unknown error occurred while fetching authorization codes'
    );
  }
};
